// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yGkw","inner":"Footer_inner__3YacV","nextIcon":"Footer_nextIcon__lED6A","innerLeft":"Footer_innerLeft__O4Rnj"};